import { Layout } from '@/utils/routerHelper'

// 消息中心
export default {
  path: '/message',
  redirect: '/message/message-template',
  component: Layout,
  name: 'Message',
  meta: {
    title: '消息中心',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'message-template',
      component: () => import('@/views/Message/MessageTemplate/Index.vue'),
      name: 'MessageTemplate',
      meta: {
        title: '消息模板'
      }
    },
    {
      path: 'add-message-template',
      component: () => import('@/views/Message/AddMessageTemplate/Index.vue'),
      name: 'AddMessageTemplate',
      meta: {
        title: '新增消息模板',
        hidden: true,
        canTo: true,
        activeMenu: '/message/message-template'
      }
    },
    {
      path: 'message-template-detail',
      component: () => import('@/views/Message/MessageTemplateDetail/Index.vue'),
      name: 'MessageTemplateDetail',
      meta: {
        title: '消息模板详情',
        hidden: true,
        canTo: true,
        activeMenu: '/message/message-template'
      }
    },
    {
      path: 'message-type',
      component: () => import('@/views/Message/MessageType/Index.vue'),
      name: 'MessageType',
      meta: {
        title: '消息类型'
      }
    },
    {
      path: 'send-message',
      component: () => import('@/views/Message/SendMessage/Index.vue'),
      name: 'SendMessage',
      meta: {
        title: '发送管理'
      }
    },
    {
      path: 'add-send-message',
      component: () => import('@/views/Message/AddSendMessage/Index.vue'),
      name: 'AddSendMessage',
      meta: {
        title: '新增发送任务',
        hidden: true,
        canTo: true,
        activeMenu: '/message/send-message'
      }
    },
    {
      path: 'send-message-detail',
      component: () => import('@/views/Message/SendMessageDetail/Index.vue'),
      name: 'SendMessageDetail',
      meta: {
        title: '发送详情',
        hidden: true,
        canTo: true,
        activeMenu: '/message/send-message'
      }
    },
    {
      path: 'send-message-detail-list',
      component: () => import('@/views/Message/SendMessageDetailList/Index.vue'),
      name: 'SendMessageDetailList',
      meta: {
        title: '消息发送情况列表',
        hidden: true,
        canTo: true,
        activeMenu: '/message/send-message'
      }
    },
    {
      path: 'sensitive-words',
      component: () => import('@/views/Message/SensitiveWords/Index.vue'),
      name: 'SensitiveWords',
      meta: {
        title: '敏感词列表'
      }
    },
    {
      path: 'edit-sensitive-words-log',
      component: () => import('@/views/Message/EditSensitiveWordsLog/Index.vue'),
      name: 'EditSensitiveWordsLog',
      meta: {
        title: '敏感词修改记录列表',
        hidden: true,
        canTo: true,
        activeMenu: '/message/sensitive-words'
      }
    },
    {
      path: 'feedback',
      component: () => import('@/views/Message/Feedback/Index.vue'),
      name: 'Feedback',
      meta: {
        title: '反馈列表'
      }
    },
    {
      path: 'feedback-detail',
      component: () => import('@/views/Message/FeedbackDetail/Index.vue'),
      name: 'FeedbackDetail',
      meta: {
        title: '反馈详情',
        hidden: true,
        canTo: true,
        activeMenu: '/message/feedback'
      }
    }
  ]
} as AppRouteRecordRaw
